document.addEventListener('DOMContentLoaded', function() {
  function getChileDate() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Santiago' }));
  }

  function getExpressText() {
    const chileDate = getChileDate();
    const day = chileDate.getDay(); // 0=domingo, 6=sábado
    const hour = chileDate.getHours();
    const minute = chileDate.getMinutes();

    if (day >= 1 && day <= 5) { 
      // Lunes a Viernes
      if (hour < 18 || (hour === 18 && minute === 0)) {
        return "RECIBE HOY";
      } else {
        return "RECIBE MAÑANA";
      }
    } else if (day === 6) {
      // Sábado
      if (hour < 13 || (hour === 13 && minute === 0)) {
        return "RECIBE HOY";
      } else {
        return "RECIBE EL LUNES";
      }
    } else if (day === 0) {
      // Domingo
      return "RECIBE MAÑANA";
    }
  }

  const expressText = getExpressText();

  const badges = document.querySelectorAll('.product__badges-express');

  badges.forEach(function(badge) {
    const badgeState = badge.querySelector('.badge-state');

    if (badgeState) {
      badgeState.textContent = expressText;
    }
  });
});